(() => {
  if (window.__metaxPageSizeInstalled) return;
  window.__metaxPageSizeInstalled = true;
  const ensurePrimary = () => {
    const list = document.querySelector('results-list[data-metax-primary-param]');
    if (!list) return;
    const param = list.dataset.metaxPrimaryParam;
    const value = list.dataset.metaxPrimaryValue;
    if (!param || !value) return;
    const url = new URL(window.location.href);
    if (url.searchParams.get(param) === value) return;
    url.searchParams.set(param, value);
    url.searchParams.delete('page');
    window.location.replace(url.toString());
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ensurePrimary, { once: true });
  else ensurePrimary();
  document.addEventListener('change', (event) => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement) || !select.matches('[data-metax-page-size]')) return;
    if (!['24', '48', '96'].includes(select.value)) return;
    const url = new URL(window.location.href);
    url.searchParams.delete('page');
    url.searchParams.delete('section_id');
    url.searchParams.delete('sections');
    if (select.value === '24') url.searchParams.delete('view');
    else url.searchParams.set('view', 'metax-' + select.value);
    url.hash = 'ResultsList';
    window.location.assign(url.toString());
  });
  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('results-list .pagination a') : null;
    if (!link) return;
    const view = new URL(window.location.href).searchParams.get('view');
    if (!['metax-48', 'metax-96'].includes(view)) return;
    const url = new URL(link.href);
    url.searchParams.set('view', view);
    link.href = url.toString();
  }, true);
})();
